import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';

import { cn } from '@sunfish/lib/utils';

/**
 * A radio option whose content is the whole affordance.
 *
 * RadioCard pairs a dot with a title and description; this is for options that
 * are shown rather than described — a swatch, a thumbnail, a layout preview —
 * where a separate indicator would just compete with the thing being chosen.
 * Selection reads from the ring, and the entire tile is the click target.
 */
const RadioTile = React.forwardRef<
	React.ElementRef<typeof RadioGroupPrimitive.Item>,
	React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, children, ...props }, ref) => (
	<RadioGroupPrimitive.Item
		ref={ref}
		className={cn(
			'group rounded-lg border-2 border-transparent p-1 text-left transition-colors',
			'hover:border-border data-[state=checked]:border-primary',
			'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
			'disabled:cursor-not-allowed disabled:opacity-50',
			className
		)}
		{...props}
	>
		{children}
	</RadioGroupPrimitive.Item>
));
RadioTile.displayName = 'RadioTile';

export { RadioTile };
